<ngx-extended-pdf-viewer [src]="src" useBrowserLocale="true" height="80vh"></ngx-extended-pdf-viewer>